import { render, staticRenderFns } from "./_partyAffairs.vue?vue&type=template&id=2b1c79a5&scoped=true"
import script from "./_partyAffairs.vue?vue&type=script&lang=js"
export * from "./_partyAffairs.vue?vue&type=script&lang=js"
import style0 from "./_partyAffairs.vue?vue&type=style&index=0&id=2b1c79a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c79a5",
  null
  
)

export default component.exports